module.exports = __webpack_public_path__ + "static/media/ba.32231661.svg";